/**
 * Created by Shen Mo on 2019/10/24
 */
import { createStore, dispatchAll } from './create';
import { combineProcessor } from './createStore/createStore';

const _baseCreateAction = (v) => v;
export const createAction =
	(store) =>
	(a, ...args) => {
		let dispatch = store.dispatch;
		let createAction = store.createAction || _baseCreateAction;
		return dispatch(createAction(a(...args)));
	};

// 常用的 action 处理
export const handleAction = (payload, category = null) => {
	let _viewActionPayload = payload;
	if (category) {
		_viewActionPayload = {
			..._viewActionPayload,
			category,
		};
	}
	return _viewActionPayload;
};

export { createStore, dispatchAll, combineProcessor };
